import { DO_LOGIN, DO_LOGOUT } from '../actions';
import { SET_AUTH, SET_PERMISSAO } from '../mutations';
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";

export default {
    state: {
        nome: null,
        user: null,
        idUser: null,
        token: null,
        idPerfilPortal: null,
        email: null,
        perfisPortal: [],
        user_no_permission: null,
        primeiroAcesso: false
    },
    getters: {
        isAuthenticated: (state) => !!state.token
    },
    actions: {
        [DO_LOGIN]({ commit }, payload) {
            return new Promise((resolve, reject) => {
                PortalCredencialWebApi.login(payload)
                    .then(res => {
                        if (res.status === 200) {
                            commit(SET_AUTH, res.data);
                            resolve(res.data);
                        } else {
                            reject(res.data);
                        }
                    })
                    .catch(erro => {
                        reject(erro);                        
                    });
            })
        },
        [DO_LOGOUT]({ commit }) {
            return new Promise((resolve) => {
                commit(SET_AUTH, {
                    nome: null,
                    user: null,
                    idUser: null,
                    token: null,
                    idPerfilPortal: null,
                    email: null,
                    perfisPortal: [],
                    user_no_permission: null,
                    primeiroAcesso: false
                });
                resolve({
                    nome: null,
                    user: null,
                    idUser: null,
                    token: null,
                    idPerfilPortal: null,
                    email: null,
                    perfisPortal: [],
                    user_no_permission: null,
                    primeiroAcesso: false
                });
            })
        }
    },
    mutations: {
        [SET_AUTH](state, payload) {            
            state.user = payload.login;
            state.nome = payload.nome;
            state.token = payload.token;
            state.email = payload.email;
            state.idPerfilPortal = payload.idPerfilPortal;
            state.idUser = payload.idUsuario;
            state.user_no_permission = {
                temPermissao: true,
                msg: "Usuário não tem permissão para acessar esta pagina."
            };            
            state.primeiroAcesso = payload.primeiroAcesso;
        },
        [SET_PERMISSAO](state, payload) {
            state.user_no_permission.temPermissao = payload.user_no_permission.temPermissao;
        }
    }
}
